import { CollectionService } from './CollectionService';
export const collectionService = new CollectionService();
